module.exports = __webpack_public_path__ + "media/images/emblems/Ebikon_LU-68278e42f88a42f64adb65c72cdc0f25.png";